export default "__VITE_PUBLIC_ASSET__39665ec7__"